module.exports = __webpack_public_path__ + "static/img/lb4.0bf4639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb4.png
// module id = wTfO
// module chunks = 0